import axios from '@/axios';

const BASE_URL = '/subscription-packages';

export const subscriptionPackageApi = {
  /**
   * 구독 상품 목록 조회
   */
  async getAll(params = {}) {
    const response = await axios.get(BASE_URL, { params });
    return response.data;
  },

  /**
   * 구독 상품 상세 조회
   */
  async getById(id) {
    const response = await axios.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * 구독 상품 생성
   */
  async create(data) {
    const response = await axios.post(BASE_URL, data);
    return response.data;
  },

  /**
   * 구독 상품 수정
   */
  async update(id, data) {
    const response = await axios.put(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  /**
   * 구독 상품 삭제
   */
  async delete(id) {
    const response = await axios.delete(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * 리셀러 목록 조회
   */
  async getResellers() {
    const response = await axios.get(`${BASE_URL}/resellers`);
    return response.data;
  },

  /**
   * 병원/제조사 목록 조회 (커스텀 타입용)
   */
  async getCustomCompanies() {
    const response = await axios.get(`${BASE_URL}/custom-companies`);
    return response.data;
  },
};

/**
 * 시스템 제품 API (가격 정보 조회용)
 */
export const systemProductApi = {
  async getAll() {
    const response = await axios.get('/system-products');
    return response.data;
  },
};
